<cm-overlay>
  <cm-setup
    title="{{ 'SETUP_AUTHENTICATE_TITLE' | translate }}"
    subTitle="{{ 'SETUP_AUTHENTICATE_SUBTITLE' | translate }}"
    [showOk]="false"
  ></cm-setup>
</cm-overlay>
